<template>
	<article class="p-6 bg-white border rounded-sm">
		<div class="flex gap-3">
			<AppIconContained :icon palette="purple" />
			<h2 class="text-lg font-semibold" style="margin-top: 0px">
				{{ heading }}
			</h2>
		</div>
		<div class="mt-5">
			<slot />
		</div>
	</article>
</template>

<script lang="ts" setup>
// TODO: allow using outline icons
interface Props {
	icon: string;
	heading: string;
}
defineProps<Props>();
</script>
